export default __webpack_public_path__ + "static/media/me.98e09f1d.jpg";